import React from "react";
import FirstFooter from "../components/FirstFooter";
import SeconsFooter from "../components/SeconsFooter";

function Footer() {
  return (
    <div className="bg-white text-font lg:px-16  py-8 ">
      <FirstFooter />
      <SeconsFooter />
    </div>
  );
}

export default Footer;
